<a class="nav-link" (click)="toggleNotifications()" style="position: relative;">
  <i class="fas fa-bell" style="font-size: 1.5rem; position: relative;"></i>
  <span
    *ngIf="notifications.length > 0"
    class="badge badge-danger position-absolute notification-badge"
  >
    {{ notifications.length }}
  </span>
</a>

<div *ngIf="showNotifications" class="notification-panel">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span>Notifications</span>
    </div>
    <div class="card-body">
      <div *ngIf="notifications.length > 0; else noNotifications">
        <ul class="list-group">
          <li *ngFor="let notification of notifications" class="list-group-item"
              (click)="onNotificationClick(notification)" style="cursor: pointer;">
            {{ notification.message }}
          </li>
        </ul>
      </div>
      <ng-template #noNotifications>
        <p class="text-muted text-center">No new notifications</p>
      </ng-template>
    </div>
  </div>
</div>
